import { AysCode, AysCodeCodingSystem } from '@bindoc-projects/code-domain-lib';

export class AysCodeAgeGroupDistribution {
  public static fromObj(
    codingSystem: AysCodeCodingSystem,
    obj: unknown,
  ): AysCodeAgeGroupDistribution {
    return new AysCodeAgeGroupDistribution(
      new AysCode(
        obj['content'].code.name,
        undefined,
        codingSystem,
        'specific',
      ),
      obj['content'].year,
      obj['content'].sum,
      obj['content'].percentageByAgmId,
      obj['additionalInformation'].text,
    );
  }

  constructor(
    public code: AysCode,
    public year: string,
    public sum: number,
    public percentageByAgmId: {
      [agmId: string]: AysCodeAgeGroupDistributionPercentageByAgmId;
    },
    public additionalInformation: string,
  ) {}
}

/**
 * percentageCountByGender has the keys 'UNKNOWN' | 'MALE' | 'FEMALE'
 */
export interface AysCodeAgeGroupDistributionPercentageByAgmId {
  count: number;
  percentage: number;
  percentageCountByGender: {
    [gender: string]: AysCodeAgeGroupDistributionPercentage;
  };
}

export interface AysCodeAgeGroupDistributionPercentage {
  count: number;
  percentage: number;
}
